<div class="dashboard-page">
  <!-- Header: date + greeting -->
  <div class="text-xs-semibold text-gray-500 mb-2 today-label">{{ todayLabel }}</div>
  <div class="dashboard-title display-md-semibold text-gray-900">Dobrodošli, korisniče!</div>
  <div class="text-md-regular text-gray-600 mt-1">Pregled vašeg naloga</div>

  <!-- Onboarding banner -->
  @if (showOnboardingBanner()) {
    <div class="banner banner--dark banner--dismissible mt-4">
      <div class="flex align-items-center gap-3 banner__content">
        <div class="banner__icon">
          <app-cube-01 stroke="#F0F2F5" width="20px" height="20px"></app-cube-01>
        </div>
        <div class="flex flex-column gap-1">
          <div class="text-md-semibold banner__title">Sledeći korak: kupovina paketa</div>
          <div class="text-sm-regular banner__sub">
            Zakazivanje termina biće dostupno nakon kupovine paketa
          </div>
        </div>
      </div>
      <svg class="banner__arc" viewBox="0 0 280 140" fill="none" aria-hidden="true">
        <circle cx="240" cy="70" r="160" stroke="rgba(255,255,255,0.12)" stroke-width="48"/>
        <circle cx="240" cy="70" r="96" stroke="rgba(255,255,255,0.08)" stroke-width="32"/>
      </svg>
      <div class="banner__actions flex align-items-center gap-2">
        <app-button
          [btnSize]="ButtonSize.MD"
          [btnSeverity]="ButtonSeverity.SECONDARY"
          (btnClicked)="goToOffer()"
        >
          <app-cube-01 stroke="#181D27" width="20px" height="20px"></app-cube-01>
          <span class="text-sm-semibold text-gray-900">Kupite paket</span>
        </app-button>
      </div>
      <button class="banner__close" (click)="dismissBanner()" aria-label="Zatvori">
        <app-x-close stroke="#FFFFFF" width="14" height="14"></app-x-close>
      </button>
    </div>
  }

  <!-- Stanje termina card -->
  <div class="status-card mt-card">
    <div class="text-lg-semibold text-gray-900">Stanje termina</div>

    <div class="stats-grid mt-card">
      <div class="stat-tile">
        <div class="stat-tile__icon">
          <app-hourglas-03 stroke="#414651" width="18px" height="18px"></app-hourglas-03>
        </div>
        <div class="ml-3 flex flex-column gap-1">
          <div class="text-sm-semibold text-gray-600">Dostupno</div>
          <div class="stat-tile__value">
            <span class="display-sm-semibold text-gray-900">{{ packageState.availableHours() }}</span>
            <span class="display-sm-semibold text-gray-400">&nbsp;h</span>
          </div>
        </div>
      </div>

      <div class="stat-tile">
        <div class="stat-tile__icon">
          <app-clock stroke="#414651" width="18px" height="18px"></app-clock>
        </div>
        <div class="ml-3 flex flex-column gap-1">
          <div class="text-sm-semibold text-gray-600">Zakazano</div>
          <div class="stat-tile__value">
            <span class="display-sm-semibold text-gray-900">{{ packageState.scheduledCount() }}</span>
            <span class="display-sm-semibold text-gray-400">&nbsp;{{ packageState.scheduledCount() === 1 ? 'termin' : 'termina' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Quick action cards -->
  <div class="actions-grid mt-card">
    <div class="action-card" (click)="goToOffer()">
      <div class="action-card__head">
        <app-cube-01 stroke="#181D27" width="20px" height="20px"></app-cube-01>
        <app-arrow-up-right stroke="#181D27" width="10px" height="10px"></app-arrow-up-right>
      </div>
      <div class="text-md-semibold text-gray-900 mt-2-5">Kupite paket</div>
      <div class="text-sm-regular text-gray-600 action-card__subtitle">Izaberite odgovarajući paket</div>
    </div>

    <div
      class="action-card"
      [class.action-card--disabled]="!canBook()"
      (click)="canBook() && goToCreateAppointment()"
    >
      <div class="action-card__head">
        <app-clock stroke="#181D27" width="20px" height="20px"></app-clock>
        <app-arrow-up-right stroke="#181D27" width="10px" height="10px"></app-arrow-up-right>
      </div>
      <div class="text-md-semibold text-gray-900 mt-2-5">Zakažite termin</div>
      <div class="text-sm-regular text-gray-600 action-card__subtitle">Izaberite vreme projekcije</div>
      @if (!canBook()) {
        <div class="action-card__hint text-sm-medium text-gray-700">Dostupno nakon kupovine paketa</div>
      }
    </div>

    <div class="action-card" (click)="goToCalendar()">
      <div class="action-card__head">
        <app-calendar stroke="#181D27" width="20px" height="20px"></app-calendar>
        <app-arrow-up-right stroke="#181D27" width="10px" height="10px"></app-arrow-up-right>
      </div>
      <div class="text-md-semibold text-gray-900 mt-2-5">Pogledajte kalendar</div>
      <div class="text-sm-regular text-gray-600 action-card__subtitle">Pregled dostupnosti termina</div>
    </div>
  </div>

  <!-- Moji termini -->
  <div class="text-lg-semibold text-gray-900 mt-4 mb-3">Moji termini</div>
  <app-client-appointments-table
    [userId]="userId"
    [isClientView]="true"
    (changed)="packageState.load()"
  ></app-client-appointments-table>
</div>
